import React, { useState, useEffect } from "react";
import * as styles from "../newStyles.styles";
import { withRedux } from "helpers";
import styled, { css } from "react-emotion";
import WebIcon from "./WebIcon";
import WebProfile from "./WebProfile";
import { isMobileDevice } from "helpers";

const isMob = isMobileDevice();

const CartIconContainer = styled("div")`
  position: fixed; /* fixes to the screen */
  z-index: 10;
  bottom: 20px;
  right: 20px;
  width: 65px;
  height: 65px;
  padding: 0;
  background-color: white;
  border-radius: 60px;
  display: flex; /* used to make the icon in the center vertically and horizontally */
  justify-content: center; /* used to make the icon in the center vertically and horizontally */
  align-items: center; /* used to make the icon in the center vertically and horizontally */
  overflow: visible !important;
  box-shadow: 0px 2px 18px 0px rgba(0, 0, 0, 0.3); /* box shadow if you want, you can copy what ever CSS you generated in the section */
`;

const numberSpan = css`
  font-size: calc(11em / 16);
  line-height: 1;
`;

const DivCount = styled("div")`
  position: fixed; /* fixes to the screen */
  z-index: 10;
  bottom: 55px;
  right: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  background-color: ${(props) => (props.color ? props.color : "#3a3a3a")};
  color: #fff;
  border-radius: 50%;
  min-width: 1em;
  height: 1em;
`;

const DivCountNav = styled("div")`
  position: absolute !important; /* fixes to the screen */
  z-index: 10;
  top: 45px;
  right: 97px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  background-color: ${(props) => (props.color ? props.color : "#3a3a3a")};
  color: #fff;
  border-radius: 50%;
  min-width: 1em;
  height: 1em;
  @media (max-width: 768px) {
    top: 22px;
    right: 93px;
  }
`;

const Nav = styled("nav")`
  display: flex;
  width: 100%;
  justify-content: space-between;
  @media (min-width: 768px) {
    /* width: 60%; */
  }
`;

const appName = css`
  display: flex;
  @media (max-width: 767px) {
    font-size: 22px;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin: 0;
    width: 258;
  }
`;
const appNameContainer = css`
  display: flex;
  font-size: 38px;
  font-weight: bold;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;

  @media (max-width: 767px) {
    font-size: 22px;
    width: 240px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    display: none;
  }
`;

const scrollBar = css`
  ::-webkit-scrollbar {
    height: 4px;
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.75);
  }

  ::-webkit-scrollbar-thumb {
    background-color: #000000;
    border-radius: 10px;
    width: 8px;
    height: 4px;
  }
`;

const NavLinks = styled("ul")`
  position: relative;
  padding: 10px 0px;
  text-align: right;
  list-style: none;
  width: 100%;
  font-size: 16px;
  overflow: auto;
  white-space: nowrap;
  letter-spacing: 0.03rem;
  color: ${(props) => (props.color ? props.color : "#89d2d3")};

  /* 576px */
  @media (max-width: 36em) {
  }
  /* mobile */
  @media (max-width: 767px) {
    display: flex;
    flex-direction: column;
    text-align: center;
    width: 100%;
    height: 100vh;
    position: absolute;
    top: 69px;
    right: -100%;
    opacity: 1;
    padding: 0px;
    transition: all 0.5s ease;
  }
`;

const WebButton = styled("button")`
  padding: 10px;
  width: 275px;
  border-radius: 4px;
  color: white;
  background: ${(props) => props.background};
  font-weight: bold;
  border: none;
  box-shadow: 3px 3px 13px rgba(120, 120, 120, 0.5);
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  cursor: pointer;

  @media (max-width: 768px) {
    margin-top: 10px;
  }
`;

const mobileNav = css`
  @media (max-width: 767px) {
    background: #fff;
    right: 0;
    opacity: 1;
    transition: all 0.5s ease;
    z-index: 1;
    overflow-y: scroll;
  }
`;

const menuIcon = css`
  display: inline-block;
  @media (min-width: 48em) {
    display: none;
  }
`;

const NavLink = styled("li")`
  display: inline-block;
  margin-bottom: 0;
  vertical-align: middle;
  color: black;
  a {
    cursor: pointer;
  }
  @media (max-width: 767px) {
    width: 100%;
    text-align: -webkit-center;
    a {
      padding: 0rem;
    }
  }
  :hover {
    color: ${(props) => props.color};
  }
`;
const NavButton = styled("a")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 16px;
  font-weight: bold;
  margin: 3px 1rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  @media (max-width: 767px) {
    display: block;
    padding: 0;
    font-size: 20px;
  }
`;

const col8 = css`
  margin-right: 20px;
`;
const col4 = css`
  margin-bottom: 10px;
`;

const navCart = css`
  display: flex;
  align-items: center;
  margin-right: 3px;
  border-radius: 25px;
  padding: 8px;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  background-color: white;
  :hover {
    transform: scale(1.1);
    background-color: #e7e7e7;
  }
`;

const LinkContainer = styled("div")`
  width: 100%;
  transition: all 0.2s ease-in-out;

  :after {
    content: "";
    display: block;
    margin: 0 auto;
    padding-top: 5px;
    border-bottom: ${(props) =>
      props.isSelected ? "2px solid" + props.color : "none"};
  }
  @media (max-width: 767px) {
    flex: 0 0 100%;
    width: 100%;
    margin: 15px 0px;
    border-bottom: none;
    :after {
      content: "";
      display: block;
      margin: 0 auto;
      width: 60%;
      padding-top: 5px;
      border-bottom: ${(props) =>
        props.isSelected ? "2px solid" + props.color : "none"};
    }
  }
`;

const inline = css`
  display: inline-block;
`;

function HeaderWebComponent(props) {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(props.activeTemplate.id);
  const [menuItems, setMenuItems] = useState([]);
  const [hovered, setHovered] = useState(false);
  const { isAdmin } = props;

  // console.log("Header got isAdmin: ");
  // console.log(isAdmin);

  const goToWebHome = () => {
    setSelected(setAboutUsAsActiveTemplate());
  };

  const goToCart = () => {
    props.actions.setTemplate(props.activeApp.id, null);
    if (isAdmin) {
      props.history.push({
        pathname: `/${props.activeApp.landingPagePath}/home?isAdmin=true`,
        state: { path: "cart" },
      });
      return;
    }
    props.history.push({
      pathname: `/${props.activeApp.landingPagePath}/home`,
      state: { path: "cart" },
    });
  };

  const setAboutUsAsActiveTemplate = () => {
    const homePage = props.activeApp.view.templates.find((t) => {
      return t.type === "aboutUs";
    }).id;
    props.actions.setTemplate(props.activeApp.id, homePage);
    return homePage;
  };

  const setActiveTemplate = () => {
    const { nav } = props;
    nav.components.sort((a, b) => {
      return a.order - b.order;
    });
    const storePage = props.activeApp.view.templates.find((t) => {
      return t.type === "store";
    }).id;
    const homePage = props.activeApp.view.templates.find((t) => {
      return t.type === "aboutUs";
    }).id;
    if (storePage) {
      props.actions.setTemplate(props.activeApp.id, storePage);
      return storePage;
    } else {
      props.actions.setTemplate(props.activeApp.id, homePage);
      return homePage;
    }
  };

  const setActiveStoreTemplate = (store) => {
    props.actions.setTemplate(props.activeApp.id, store);
  };

  const toggleMenu = () => setOpen(!open);
  const toggleHover = () => setHovered(!hovered);

  useEffect(() => {
    getMenuItems();
  }, []);

  const getMenuClassName = () => {
    if (open) return mobileNav;
    if (hovered) return scrollBar;
    return "";
  };

  const renderFixedCartOnMobile = () => {
    const { nav } = props;
    if (
      props.cart.cartQty > 0 &&
      props.platformInfo.display.templateId != null
    ) {
      return (
        <CartIconContainer>
          <a className={navCart} onClick={goToCart}>
            <WebIcon
              iconName={"cart"}
              useColor={true}
              size={"20px"}
              className={inline}
            />
          </a>
          <DivCount color={nav.navBarColor}>
            <span className={numberSpan}>{props.cart.cartQty}</span>
          </DivCount>
        </CartIconContainer>
      );
    }
  };

  const getMenuItems = () => {
    const { activeApp, actions, nav } = props;

    nav.components.sort((a, b) => {
      return a.order - b.order;
    });
    let temp = [];
    let storeFound = false;
    nav.components.forEach((template) => {
      // console.dir(template);
      // console.log(template.order + ": " + template.title.text);
      const type = activeApp.view.templates.find(
        (t) => t.id === template.templateId
      ).type;
      // console.log("GOT TYPE: " + type);
      const listFunc = () => {
        actions.setTemplate(activeApp.id, template.templateId);
        setSelected(template.templateId);
        setOpen(false);
        // this.props.history.push({
        //   pathname: `/${activeApp.landingPagePath}/${component.templateId}`,
        // });
      };
      if (type === "store" && !storeFound) {
        setActiveStoreTemplate(template.templateId);
        setSelected(template.templateId);
        storeFound = true;
      }
      if (type != "rewards" && type != "website")
        temp.push({
          id: template.templateId,
          listText: template.title.text,
          listFunc: listFunc,
        });
      if (type === "website") {
        const websiteTemplate = props.activeApp.view.templates.find((t) => {
          return t.id === template.templateId;
        });
        const url = websiteTemplate.components[0].view.url;
        const redirectFunc = () => {
          window.open(url, "_blank");
        };
        temp.push({
          id: template.templateId,
          listText: template.title.text,
          listFunc: redirectFunc,
        });
      }
    });
    if (!storeFound) {
      setSelected(setAboutUsAsActiveTemplate());
    }
    setMenuItems(temp);
  };

  const renderWebMenu = () => {
    const { nav } = props;

    return (
      <Nav
        // className={styles.row}
        style={{
          marginBottom: "0px",
          marginTop: "-20px",
        }}
      >
        {renderFixedCartOnMobile()}
        <div className={col8} style={{ width: "75%" }}>
          <NavLinks
            color={nav.navBarColor}
            className={getMenuClassName()}
            onMouseOver={toggleHover}
            onMouseOut={toggleHover}
          >
            {menuItems.map((page) => {
              const isSelected = selected === page.id;
              // if (isSelected) {
              //   console.log(page.listText + " is selected!");
              // }

              return (
                <NavLink
                  color={nav.navBarColor}
                  className={"nav-link"}
                  key={page.id}
                >
                  <LinkContainer
                    color={nav.navBarColor}
                    isSelected={isSelected}
                  >
                    <NavButton onClick={page.listFunc} key={page.listText}>
                      {page.listText}
                    </NavButton>
                  </LinkContainer>
                </NavLink>
              );
            })}
          </NavLinks>
        </div>

        <div className={col4}>
          <a
            href={props.activeApp.deeplinkUrl}
            target="_blank"
            style={{ textDecoration: "none" }}
          >
            <WebButton background={nav.navBarColor}>
              Download Our Mobile360 App!
            </WebButton>
          </a>
          {/* <a onClick={goToConfirm}>Go to confirm</a> */}
        </div>
      </Nav>
    );
  };
  const { nav } = props;

  return (
    <styles.WebHeader>
      {/* Logo to the left */}
      <div
        className={styles.row}
        style={{
          marginBottom: "0px",
          alignItems: "center",
          width: "100%",
          justifyContent: "space-between",
          padding: "0px",
          backgroundColor: "white",
        }}
      >
        {props.activeApp.logo && (
          <img
            src={props.activeApp ? props.activeApp.logo : null}
            alt="header-logo"
            className={styles.webHeaderLogoPic}
            onClick={goToWebHome}
          />
        )}

        <div className={appNameContainer}>
          {props.activeApp ? props.activeApp.name : null}
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            backgroundColor: "white",
          }}
        >
          <a onClick={goToCart}>
            <WebIcon
              iconName={"cart"}
              useColor={true}
              size={"20px"}
              // className={inline}
              hover={true}
            />
            {props.cart.cartQty > 0 ? (
              <DivCountNav color={nav.navBarColor}>
                <span className={numberSpan}>{props.cart.cartQty}</span>
              </DivCountNav>
            ) : null}
          </a>

          <WebProfile />
          <div onClick={toggleMenu} className={menuIcon}>
            {open ? (
              <WebIcon
                iconName={"cancel"}
                useColor={true}
                size={"20px"}
                hover={true}
              />
            ) : (
              <WebIcon
                iconName={"burger"}
                useColor={true}
                size={"20px"}
                hover={true}
              />
            )}
          </div>
        </div>
      </div>
      <div
        className={styles.row}
        style={{
          marginBottom: "0px",
          width: "100%",
          justifyContent: "flex-end",
          backgroundColor: "white",
        }}
      >
        {renderWebMenu()}
      </div>
    </styles.WebHeader>
  );
}

export default withRedux(HeaderWebComponent);
